// Slides host object
async function vsto_insertSlideFromUrl(url) {
  let hostObject = window.chrome.webview.hostObjects.slidesHostObject;
  let index = await hostObject.insertSlideFromFile(url);
  return index;
}

async function vsto_updateSlide_Title(index, slideData) {
  let hostObject = window.chrome.webview.hostObjects.slidesHostObject;
  await hostObject.updateSlide_Title(index, slideData);
}

async function vsto_updateSlide_Title_Content(index, slideData) {
  let hostObject = window.chrome.webview.hostObjects.slidesHostObject;
  await hostObject.updateSlide_Title_Content(index, slideData);
}

async function vsto_getCurPageNumber() {
  let hostObject = window.chrome.webview.hostObjects.slidesHostObject;
  let index = await hostObject.getCurPageNumber();
  return index;
}

export default {
  vsto_insertSlideFromUrl,
  vsto_updateSlide_Title,
  vsto_updateSlide_Title_Content,
  vsto_getCurPageNumber,
};
